var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"container"},_vm._l((_vm.confsMobile),function(conf,index){return _c('li',{key:index},[(conf.link!=='javascript:void(0)')?[_c('a',{staticClass:"has-no-link",attrs:{"href":conf.link,"target":"_blank"}},[_c('img',{attrs:{"src":conf.img,"alt":""}})])]:[_c('img',{attrs:{"src":conf.img,"alt":""}})]],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }